import { Component, AfterViewInit, ElementRef, Input, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { Store } from '@ngrx/store';
import { StockCardsComponent } from '../../../partials/stock-cards/stock-cards.component';

@Component({
    selector: 'card-loading',
    templateUrl: './card-loading.component.html',
    styleUrls: ['./card-loading.component.scss'],
})
export class CardLoadingComponent extends StockCardsComponent implements AfterViewInit{

    @Input() public cardType: string;

    constructor(
        protected router: Router,
        protected dialogService: DialogsService,
        protected store: Store<AppState>,
        private elementRef: ElementRef,
        protected changeDetectorRef: ChangeDetectorRef
    ) {
        super(router, dialogService, store, changeDetectorRef);
    }

    public ngAfterViewInit() {
        super.ngAfterViewInit();
        setTimeout(() => {
            if (
                this.elementCard &&
                this.elementRef.nativeElement &&
                this.elementRef.nativeElement.parentElement
            ) {
                (<HTMLElement> this.elementCard.nativeElement.parentElement)
                .style.height = this.elementRef.nativeElement.parentElement.offsetHeight + 1 + 'px';

                (<HTMLElement> this.elementCard.nativeElement)
                .style.height = this.elementRef.nativeElement.parentElement.offsetHeight + 1 + 'px';

                (<HTMLElement> this.elementCard.nativeElement.parentElement)
                .style.width = this.elementRef.nativeElement.nextElementSibling.offsetWidth + 'px';

                (<HTMLElement> this.elementCard.nativeElement
                ).style.width = this.elementRef.nativeElement.parentElement.offsetWidth + 'px';
            }
        }, 700);
    }

}